import ClockIcon from "assets/icons/ClockIcon";
import LikeIcon from "assets/icons/LikeIcon";
import StudentHatIcon from "assets/icons/StudentHatIcon";
import BenefitsCard from "components/common/Card/BenefitsCard";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import { useModal } from "context/hooks/useModal";
import React, { FC, useMemo } from "react";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import styles from "../index.module.scss";
import { t } from "i18next";

const HighlightningBenefits: FC = () => {
  const { lifeChoice } = useLifeChoicePageContext();
  const { showModal } = useModal();
  const { language, dir } = useAppSelector(getSettings);

  const benefitCards = useMemo(
    () => [
      {
        icon: <StudentHatIcon size={25} />,
        title: lifeChoice?.certificate_type?.section[language],
        value: lifeChoice?.certificate_type?.initials,
        description: lifeChoice?.certificate_type?.description,
        modalTitle: lifeChoice?.certificate_type?.title,
      },
      {
        icon: <ClockIcon size={25} />,
        title: <>{t('durationKPI')}</>,
        value: (
          <>
            {lifeChoice?.duration.value} <span className="text-sm">{lifeChoice?.duration.type?.[language]}</span>
          </>
        ),
      },
      {
        icon: <LikeIcon size={25} />,
        title: <>{t("successRate")}</>,
        value: `${lifeChoice?.success_rate}`,
      },
    ],
    [lifeChoice]
  );

  if (!language) return null;

  return (
    <div className={`${styles["highlightning-benefits"]} w-full`} dir={dir}>
      {benefitCards.map(
        ({ icon, title, value, description, modalTitle }, idx) => (
          <BenefitsCard
            key={`--benefit-card-${title}-${idx}`}
            icon={icon}
            title={title}
            value={value}
            onClick={() =>
              description &&
              showModal(
                <div>
                  <h3 className="tex-xl font-semibold">{modalTitle}</h3>
                  <p dir={dir} lang={language}>
                    {description[language]}
                  </p>
                </div>,
                "sm"
              )
            }
          />
        )
      )}
    </div>
  );
};

export default HighlightningBenefits;
